import styled from "styled-components";
import { mediaMaxWidth, mediaMinWidth } from "../../utils/mediaQueriesTemplate";

export const RouterNav = styled.nav`
  position: fixed;
  top: 116px;
  width: calc(100% - 60px);
  z-index: 1;
  background-color: #e4e5e7;
  height: 55px;
  align-items: center;
  transition: 0.2s ease-in-out;

  ${mediaMaxWidth.tablet`
    width: 100%;
    margin-left: 0;

    &.downScroll {
      top: 57px;
    }
  `}
`;

export const RouterList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 5px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  ${mediaMaxWidth.tablet`
    height: calc(100% - 5px);
    background-color: #fff;
  `}
`;

export const RouterItem = styled.li`
  display: flex;
  justify-content: center;
  padding: 5px 15px;
  font-weight: 700;
  margin: 0 10px;
  flex-direction: column;
  position: relative;

  a {
    color: #333;

    &::after {
      content: "";
      display: block;
      width: 0;
      height: 5px;
      background: #f2008c;
      transition: width 0.2s;
      position: relative;
      top: 5px;
      left: -15px;

      ${mediaMaxWidth.tablet`
        top: 7px;
        left: -5px;
      `}
    }

    &:hover {
      &::after {
        width: calc(100% + 30px);

        ${mediaMaxWidth.tablet`
          width: calc(100% + 10px);
        `}
      }
    }
  }

  a.active {
    &::after {
      content: "";
      display: block;
      width: calc(100% + 30px);
      height: 5px;
      background: #f2008c;
      position: relative;
      top: 5px;
      left: -15px;

      ${mediaMaxWidth.tablet`
        width: calc(100% + 10px);
        top: 7px;
        left: -5px;
      `}
    }
  }

  ${mediaMaxWidth.tablet`
    flex: 1;
    margin: 0;
    padding: 5px 5px;
    text-align: center;
  `}
`;

export const TabIcon = styled.div`
  color: #4a4a4a;

  ${mediaMinWidth.tablet`
    display: none;
  `}
`;

export const TabText = styled.div`
  ${mediaMaxWidth.tablet`
    text-transform: uppercase;
    font-size: .65em;
    font-weight: 600;
    position: relative;
    top: 3px;
  `}
`;

export const BackLink = styled.div`
  display: none;

  a {
    position: fixed;
    top: 77px;
    z-index: 4;
    left: 80px;
    font-size: 1em;
    font-weight: 500;
    letter-spacing: 0.03em;
    cursor: pointer;
    color: #fff !important;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #f2008c !important;
    }

    &::before {
      content: "<";
      position: relative;
      top: -2px;
      left: -5px;
    }
  }

  ${mediaMinWidth.tablet`
    display: block;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -52px;
`;

export const CardWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 700px;
  padding: 10px 20px;
  position: relative;
  overflow: hidden;
  color: #565656;
  box-shadow: 0 0 15px #dcdcdc;
  margin: 0 auto;

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 20px);
    margin: 0 auto 50px auto;
  `}

  &.animated {
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInLeft {
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
  }
`;

export const Body = styled.div`
  color: #565656;
  padding: 5px 10px;
  display: flex;
`;

export const Row = styled.div`
  margin: 10px 0 50px 0;

  ${mediaMaxWidth.phone`
    margin: 0;
  `}

  &:last-of-type {
    margin: 10px 0 20px 0;
  }
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #d8d8d8;
  padding: 5px 10px;

  ${mediaMaxWidth.tablet`
    display: unset;
    width: 50%;
    float: left;
    line-height: 2em;
    border-bottom: none;
    padding: 0px;
  `}

  ${mediaMaxWidth.tablet`
    line-height: 1.5em;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 60%;
  `}
`;

export const ColumnTitle = styled.div`
  display: flex;
  flex: 1;
  font-weight: 600;
  font-size: 1em;

  ${mediaMaxWidth.tablet`
    font-size: 0.85em;
  `}
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;

  ${mediaMaxWidth.tablet`
    display: unset;
    width: 30%;
    float: right;
    font-size: 1em;
    line-height: 2em;
    padding: 0px;
  `}

  ${mediaMaxWidth.tablet`
    line-height: 1.5em;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 25%;
  `}
`;

export const ColumnData = styled.div`
  display: flex;
  flex: 1;
  font-size: 2em;
  font-weight: 400;

  ${mediaMaxWidth.tablet`
    font-size: 0.85em;
    font-weight: 400;
  `}
`;

export const TabButtons = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 10px 0;
`;

export const TabButton = styled.div`
  padding: 5px 15px;
  margin: 0px 10px;
  font-weight: 700;

  &::after {
    content: "";
    display: block;
    width: 0px;
    height: 5px;
    position: relative;
    top: 5px;
    left: -15px;
    background: rgb(242, 0, 140);
    transition: width 0.2s ease 0s;
  }

  &:hover {
    cursor: pointer;

    &::after {
      content: "";
      display: block;
      width: calc(100% + 30px);
      height: 5px;
      position: relative;
      top: 5px;
      left: -15px;
      background: rgb(242, 0, 140);
    }
  }

  &.active {
    &::after {
      content: "";
      display: block;
      width: calc(100% + 30px);
      height: 5px;
      position: relative;
      top: 5px;
      left: -15px;
      background: rgb(242, 0, 140);
    }
  }
`;

export const Table = styled.div`
  padding: 10px 20px;

  ${mediaMaxWidth.tablet`
    padding: 0;
    font-size: 0.85em;
  `}
`;

export const TableRow = styled.div`
  display: flex;
  margin: 5px 0;
`;

export const TableColumn = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  font-weight: ${(props) => props.bold && "700"};

  strong {
    margin-right: 3px;
  }

  ${mediaMaxWidth.phone`
    align-items: flex-start;

    svg {
      margin-top: 3px;
    }
  `}
`;
